

import { createSlice } from "@reduxjs/toolkit";
import { IOrder } from "../interface/IOrder";

const initialState: IOrder | null = null;

const orderSlice = createSlice({
    name: "order",
    initialState,
    reducers: {
        setOrderInStore: (state: IOrder | null, action: any | null) => {
            return action.payload;
        },
        setOrderInStoreNull: (state, action) => {
            return null;
        }
    },
});


export const { setOrderInStore, setOrderInStoreNull } = orderSlice.actions;

export default orderSlice.reducer;
